// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.5
//   protoc               v6.33.4
// source: api_integrations.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "./google/protobuf/timestamp";

export const protobufPackage = "api_integrations";

export interface ApiIntegrations {
  apiIntegrations: ApiIntegration[];
}

export interface ApiIntegration {
  id: string;
  name: string;
  description: string;
  environments: Environments | undefined;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt: Date | undefined;
  updatedBy: string;
  operations: ApiIntegrationOperation[];
}

export interface Environments {
  sandbox: ApiIntegrationConfig | undefined;
  preRelease: ApiIntegrationConfig | undefined;
  live: ApiIntegrationConfig | undefined;
}

export interface ApiIntegrationConfig {
  baseUrl: string;
  authType: string;
}

export interface ApiIntegrationOperation {
  id: string;
  name: string;
  method: string;
  resource: string;
  createdAt: Date | undefined;
  createdBy: string;
  updatedAt: Date | undefined;
  updatedBy: string;
}

export interface ApiIntegrationCreate {
  id: string;
  name: string;
  description?: string | undefined;
  environments?: Environments | undefined;
}

export interface ApiIntegrationUpdate {
  id: string;
  name?: string | undefined;
  description?: string | undefined;
}

export interface ApiIntegrationDelete {
  id: string;
}

export interface ApiIntegrationConfigUpdate {
  id: string;
  environment: string;
  baseUrl?: string | undefined;
  authType?: string | undefined;
}

export interface ApiIntegrationOperationCreate {
  name: string;
  method: string;
  resource: string;
  integrationId: string;
  id: string;
}

export interface ApiIntegrationOperationUpdate {
  id: string;
  name?: string | undefined;
  method?: string | undefined;
  resource?: string | undefined;
  integrationId?: string | undefined;
}

export interface ApiIntegrationOperationDelete {
  id: string;
  integrationId: string;
}

function createBaseApiIntegrations(): ApiIntegrations {
  return { apiIntegrations: [] };
}

export const ApiIntegrations: MessageFns<ApiIntegrations> = {
  encode(message: ApiIntegrations, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.apiIntegrations) {
      ApiIntegration.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiIntegrations {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiIntegrations();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.apiIntegrations.push(ApiIntegration.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiIntegrations {
    return {
      apiIntegrations: globalThis.Array.isArray(object?.apiIntegrations)
        ? object.apiIntegrations.map((e: any) => ApiIntegration.fromJSON(e))
        : globalThis.Array.isArray(object?.api_integrations)
        ? object.api_integrations.map((e: any) => ApiIntegration.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiIntegrations): unknown {
    const obj: any = {};
    if (message.apiIntegrations?.length) {
      obj.apiIntegrations = message.apiIntegrations.map((e) => ApiIntegration.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ApiIntegrations>): ApiIntegrations {
    return ApiIntegrations.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApiIntegrations>): ApiIntegrations {
    const message = createBaseApiIntegrations();
    message.apiIntegrations = object.apiIntegrations?.map((e) => ApiIntegration.fromPartial(e)) || [];
    return message;
  },
};

function createBaseApiIntegration(): ApiIntegration {
  return {
    id: "",
    name: "",
    description: "",
    environments: undefined,
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: "",
    operations: [],
  };
}

export const ApiIntegration: MessageFns<ApiIntegration> = {
  encode(message: ApiIntegration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== "") {
      writer.uint32(26).string(message.description);
    }
    if (message.environments !== undefined) {
      Environments.encode(message.environments, writer.uint32(34).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(42).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(50).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(58).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(66).string(message.updatedBy);
    }
    for (const v of message.operations) {
      ApiIntegrationOperation.encode(v!, writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiIntegration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiIntegration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.environments = Environments.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.operations.push(ApiIntegrationOperation.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiIntegration {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      environments: isSet(object.environments) ? Environments.fromJSON(object.environments) : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
      operations: globalThis.Array.isArray(object?.operations)
        ? object.operations.map((e: any) => ApiIntegrationOperation.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ApiIntegration): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.environments !== undefined) {
      obj.environments = Environments.toJSON(message.environments);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    if (message.operations?.length) {
      obj.operations = message.operations.map((e) => ApiIntegrationOperation.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ApiIntegration>): ApiIntegration {
    return ApiIntegration.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApiIntegration>): ApiIntegration {
    const message = createBaseApiIntegration();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? "";
    message.environments = (object.environments !== undefined && object.environments !== null)
      ? Environments.fromPartial(object.environments)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    message.operations = object.operations?.map((e) => ApiIntegrationOperation.fromPartial(e)) || [];
    return message;
  },
};

function createBaseEnvironments(): Environments {
  return { sandbox: undefined, preRelease: undefined, live: undefined };
}

export const Environments: MessageFns<Environments> = {
  encode(message: Environments, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.sandbox !== undefined) {
      ApiIntegrationConfig.encode(message.sandbox, writer.uint32(10).fork()).join();
    }
    if (message.preRelease !== undefined) {
      ApiIntegrationConfig.encode(message.preRelease, writer.uint32(18).fork()).join();
    }
    if (message.live !== undefined) {
      ApiIntegrationConfig.encode(message.live, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Environments {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnvironments();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.sandbox = ApiIntegrationConfig.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.preRelease = ApiIntegrationConfig.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.live = ApiIntegrationConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Environments {
    return {
      sandbox: isSet(object.sandbox) ? ApiIntegrationConfig.fromJSON(object.sandbox) : undefined,
      preRelease: isSet(object.preRelease)
        ? ApiIntegrationConfig.fromJSON(object.preRelease)
        : isSet(object.pre_release)
        ? ApiIntegrationConfig.fromJSON(object.pre_release)
        : undefined,
      live: isSet(object.live) ? ApiIntegrationConfig.fromJSON(object.live) : undefined,
    };
  },

  toJSON(message: Environments): unknown {
    const obj: any = {};
    if (message.sandbox !== undefined) {
      obj.sandbox = ApiIntegrationConfig.toJSON(message.sandbox);
    }
    if (message.preRelease !== undefined) {
      obj.preRelease = ApiIntegrationConfig.toJSON(message.preRelease);
    }
    if (message.live !== undefined) {
      obj.live = ApiIntegrationConfig.toJSON(message.live);
    }
    return obj;
  },

  create(base?: DeepPartial<Environments>): Environments {
    return Environments.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Environments>): Environments {
    const message = createBaseEnvironments();
    message.sandbox = (object.sandbox !== undefined && object.sandbox !== null)
      ? ApiIntegrationConfig.fromPartial(object.sandbox)
      : undefined;
    message.preRelease = (object.preRelease !== undefined && object.preRelease !== null)
      ? ApiIntegrationConfig.fromPartial(object.preRelease)
      : undefined;
    message.live = (object.live !== undefined && object.live !== null)
      ? ApiIntegrationConfig.fromPartial(object.live)
      : undefined;
    return message;
  },
};

function createBaseApiIntegrationConfig(): ApiIntegrationConfig {
  return { baseUrl: "", authType: "" };
}

export const ApiIntegrationConfig: MessageFns<ApiIntegrationConfig> = {
  encode(message: ApiIntegrationConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.baseUrl !== "") {
      writer.uint32(10).string(message.baseUrl);
    }
    if (message.authType !== "") {
      writer.uint32(18).string(message.authType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiIntegrationConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiIntegrationConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.baseUrl = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.authType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiIntegrationConfig {
    return {
      baseUrl: isSet(object.baseUrl)
        ? globalThis.String(object.baseUrl)
        : isSet(object.base_url)
        ? globalThis.String(object.base_url)
        : "",
      authType: isSet(object.authType)
        ? globalThis.String(object.authType)
        : isSet(object.auth_type)
        ? globalThis.String(object.auth_type)
        : "",
    };
  },

  toJSON(message: ApiIntegrationConfig): unknown {
    const obj: any = {};
    if (message.baseUrl !== "") {
      obj.baseUrl = message.baseUrl;
    }
    if (message.authType !== "") {
      obj.authType = message.authType;
    }
    return obj;
  },

  create(base?: DeepPartial<ApiIntegrationConfig>): ApiIntegrationConfig {
    return ApiIntegrationConfig.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApiIntegrationConfig>): ApiIntegrationConfig {
    const message = createBaseApiIntegrationConfig();
    message.baseUrl = object.baseUrl ?? "";
    message.authType = object.authType ?? "";
    return message;
  },
};

function createBaseApiIntegrationOperation(): ApiIntegrationOperation {
  return {
    id: "",
    name: "",
    method: "",
    resource: "",
    createdAt: undefined,
    createdBy: "",
    updatedAt: undefined,
    updatedBy: "",
  };
}

export const ApiIntegrationOperation: MessageFns<ApiIntegrationOperation> = {
  encode(message: ApiIntegrationOperation, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.method !== "") {
      writer.uint32(26).string(message.method);
    }
    if (message.resource !== "") {
      writer.uint32(34).string(message.resource);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(42).fork()).join();
    }
    if (message.createdBy !== "") {
      writer.uint32(50).string(message.createdBy);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(58).fork()).join();
    }
    if (message.updatedBy !== "") {
      writer.uint32(66).string(message.updatedBy);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiIntegrationOperation {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiIntegrationOperation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.method = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.resource = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.updatedBy = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiIntegrationOperation {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      method: isSet(object.method) ? globalThis.String(object.method) : "",
      resource: isSet(object.resource) ? globalThis.String(object.resource) : "",
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : "",
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      updatedBy: isSet(object.updatedBy)
        ? globalThis.String(object.updatedBy)
        : isSet(object.updated_by)
        ? globalThis.String(object.updated_by)
        : "",
    };
  },

  toJSON(message: ApiIntegrationOperation): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.method !== "") {
      obj.method = message.method;
    }
    if (message.resource !== "") {
      obj.resource = message.resource;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.createdBy !== "") {
      obj.createdBy = message.createdBy;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.updatedBy !== "") {
      obj.updatedBy = message.updatedBy;
    }
    return obj;
  },

  create(base?: DeepPartial<ApiIntegrationOperation>): ApiIntegrationOperation {
    return ApiIntegrationOperation.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApiIntegrationOperation>): ApiIntegrationOperation {
    const message = createBaseApiIntegrationOperation();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.method = object.method ?? "";
    message.resource = object.resource ?? "";
    message.createdAt = object.createdAt ?? undefined;
    message.createdBy = object.createdBy ?? "";
    message.updatedAt = object.updatedAt ?? undefined;
    message.updatedBy = object.updatedBy ?? "";
    return message;
  },
};

function createBaseApiIntegrationCreate(): ApiIntegrationCreate {
  return { id: "", name: "", description: undefined, environments: undefined };
}

export const ApiIntegrationCreate: MessageFns<ApiIntegrationCreate> = {
  encode(message: ApiIntegrationCreate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(26).string(message.description);
    }
    if (message.environments !== undefined) {
      Environments.encode(message.environments, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiIntegrationCreate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiIntegrationCreate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.environments = Environments.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiIntegrationCreate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      environments: isSet(object.environments) ? Environments.fromJSON(object.environments) : undefined,
    };
  },

  toJSON(message: ApiIntegrationCreate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.environments !== undefined) {
      obj.environments = Environments.toJSON(message.environments);
    }
    return obj;
  },

  create(base?: DeepPartial<ApiIntegrationCreate>): ApiIntegrationCreate {
    return ApiIntegrationCreate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApiIntegrationCreate>): ApiIntegrationCreate {
    const message = createBaseApiIntegrationCreate();
    message.id = object.id ?? "";
    message.name = object.name ?? "";
    message.description = object.description ?? undefined;
    message.environments = (object.environments !== undefined && object.environments !== null)
      ? Environments.fromPartial(object.environments)
      : undefined;
    return message;
  },
};

function createBaseApiIntegrationUpdate(): ApiIntegrationUpdate {
  return { id: "", name: undefined, description: undefined };
}

export const ApiIntegrationUpdate: MessageFns<ApiIntegrationUpdate> = {
  encode(message: ApiIntegrationUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.description !== undefined) {
      writer.uint32(26).string(message.description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiIntegrationUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiIntegrationUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiIntegrationUpdate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
    };
  },

  toJSON(message: ApiIntegrationUpdate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    return obj;
  },

  create(base?: DeepPartial<ApiIntegrationUpdate>): ApiIntegrationUpdate {
    return ApiIntegrationUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApiIntegrationUpdate>): ApiIntegrationUpdate {
    const message = createBaseApiIntegrationUpdate();
    message.id = object.id ?? "";
    message.name = object.name ?? undefined;
    message.description = object.description ?? undefined;
    return message;
  },
};

function createBaseApiIntegrationDelete(): ApiIntegrationDelete {
  return { id: "" };
}

export const ApiIntegrationDelete: MessageFns<ApiIntegrationDelete> = {
  encode(message: ApiIntegrationDelete, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiIntegrationDelete {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiIntegrationDelete();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiIntegrationDelete {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: ApiIntegrationDelete): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<ApiIntegrationDelete>): ApiIntegrationDelete {
    return ApiIntegrationDelete.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApiIntegrationDelete>): ApiIntegrationDelete {
    const message = createBaseApiIntegrationDelete();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseApiIntegrationConfigUpdate(): ApiIntegrationConfigUpdate {
  return { id: "", environment: "", baseUrl: undefined, authType: undefined };
}

export const ApiIntegrationConfigUpdate: MessageFns<ApiIntegrationConfigUpdate> = {
  encode(message: ApiIntegrationConfigUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.environment !== "") {
      writer.uint32(18).string(message.environment);
    }
    if (message.baseUrl !== undefined) {
      writer.uint32(26).string(message.baseUrl);
    }
    if (message.authType !== undefined) {
      writer.uint32(34).string(message.authType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiIntegrationConfigUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiIntegrationConfigUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.environment = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.baseUrl = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.authType = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiIntegrationConfigUpdate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      environment: isSet(object.environment) ? globalThis.String(object.environment) : "",
      baseUrl: isSet(object.baseUrl)
        ? globalThis.String(object.baseUrl)
        : isSet(object.base_url)
        ? globalThis.String(object.base_url)
        : undefined,
      authType: isSet(object.authType)
        ? globalThis.String(object.authType)
        : isSet(object.auth_type)
        ? globalThis.String(object.auth_type)
        : undefined,
    };
  },

  toJSON(message: ApiIntegrationConfigUpdate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.environment !== "") {
      obj.environment = message.environment;
    }
    if (message.baseUrl !== undefined) {
      obj.baseUrl = message.baseUrl;
    }
    if (message.authType !== undefined) {
      obj.authType = message.authType;
    }
    return obj;
  },

  create(base?: DeepPartial<ApiIntegrationConfigUpdate>): ApiIntegrationConfigUpdate {
    return ApiIntegrationConfigUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApiIntegrationConfigUpdate>): ApiIntegrationConfigUpdate {
    const message = createBaseApiIntegrationConfigUpdate();
    message.id = object.id ?? "";
    message.environment = object.environment ?? "";
    message.baseUrl = object.baseUrl ?? undefined;
    message.authType = object.authType ?? undefined;
    return message;
  },
};

function createBaseApiIntegrationOperationCreate(): ApiIntegrationOperationCreate {
  return { name: "", method: "", resource: "", integrationId: "", id: "" };
}

export const ApiIntegrationOperationCreate: MessageFns<ApiIntegrationOperationCreate> = {
  encode(message: ApiIntegrationOperationCreate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.method !== "") {
      writer.uint32(26).string(message.method);
    }
    if (message.resource !== "") {
      writer.uint32(34).string(message.resource);
    }
    if (message.integrationId !== "") {
      writer.uint32(42).string(message.integrationId);
    }
    if (message.id !== "") {
      writer.uint32(58).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiIntegrationOperationCreate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiIntegrationOperationCreate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.method = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.resource = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.integrationId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiIntegrationOperationCreate {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      method: isSet(object.method) ? globalThis.String(object.method) : "",
      resource: isSet(object.resource) ? globalThis.String(object.resource) : "",
      integrationId: isSet(object.integrationId)
        ? globalThis.String(object.integrationId)
        : isSet(object.integration_id)
        ? globalThis.String(object.integration_id)
        : "",
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: ApiIntegrationOperationCreate): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.method !== "") {
      obj.method = message.method;
    }
    if (message.resource !== "") {
      obj.resource = message.resource;
    }
    if (message.integrationId !== "") {
      obj.integrationId = message.integrationId;
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create(base?: DeepPartial<ApiIntegrationOperationCreate>): ApiIntegrationOperationCreate {
    return ApiIntegrationOperationCreate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApiIntegrationOperationCreate>): ApiIntegrationOperationCreate {
    const message = createBaseApiIntegrationOperationCreate();
    message.name = object.name ?? "";
    message.method = object.method ?? "";
    message.resource = object.resource ?? "";
    message.integrationId = object.integrationId ?? "";
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseApiIntegrationOperationUpdate(): ApiIntegrationOperationUpdate {
  return { id: "", name: undefined, method: undefined, resource: undefined, integrationId: undefined };
}

export const ApiIntegrationOperationUpdate: MessageFns<ApiIntegrationOperationUpdate> = {
  encode(message: ApiIntegrationOperationUpdate, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.name !== undefined) {
      writer.uint32(18).string(message.name);
    }
    if (message.method !== undefined) {
      writer.uint32(26).string(message.method);
    }
    if (message.resource !== undefined) {
      writer.uint32(34).string(message.resource);
    }
    if (message.integrationId !== undefined) {
      writer.uint32(42).string(message.integrationId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiIntegrationOperationUpdate {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiIntegrationOperationUpdate();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.method = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.resource = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.integrationId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiIntegrationOperationUpdate {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      name: isSet(object.name) ? globalThis.String(object.name) : undefined,
      method: isSet(object.method) ? globalThis.String(object.method) : undefined,
      resource: isSet(object.resource) ? globalThis.String(object.resource) : undefined,
      integrationId: isSet(object.integrationId)
        ? globalThis.String(object.integrationId)
        : isSet(object.integration_id)
        ? globalThis.String(object.integration_id)
        : undefined,
    };
  },

  toJSON(message: ApiIntegrationOperationUpdate): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.name !== undefined) {
      obj.name = message.name;
    }
    if (message.method !== undefined) {
      obj.method = message.method;
    }
    if (message.resource !== undefined) {
      obj.resource = message.resource;
    }
    if (message.integrationId !== undefined) {
      obj.integrationId = message.integrationId;
    }
    return obj;
  },

  create(base?: DeepPartial<ApiIntegrationOperationUpdate>): ApiIntegrationOperationUpdate {
    return ApiIntegrationOperationUpdate.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApiIntegrationOperationUpdate>): ApiIntegrationOperationUpdate {
    const message = createBaseApiIntegrationOperationUpdate();
    message.id = object.id ?? "";
    message.name = object.name ?? undefined;
    message.method = object.method ?? undefined;
    message.resource = object.resource ?? undefined;
    message.integrationId = object.integrationId ?? undefined;
    return message;
  },
};

function createBaseApiIntegrationOperationDelete(): ApiIntegrationOperationDelete {
  return { id: "", integrationId: "" };
}

export const ApiIntegrationOperationDelete: MessageFns<ApiIntegrationOperationDelete> = {
  encode(message: ApiIntegrationOperationDelete, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.integrationId !== "") {
      writer.uint32(18).string(message.integrationId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ApiIntegrationOperationDelete {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseApiIntegrationOperationDelete();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.integrationId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ApiIntegrationOperationDelete {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      integrationId: isSet(object.integrationId)
        ? globalThis.String(object.integrationId)
        : isSet(object.integration_id)
        ? globalThis.String(object.integration_id)
        : "",
    };
  },

  toJSON(message: ApiIntegrationOperationDelete): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.integrationId !== "") {
      obj.integrationId = message.integrationId;
    }
    return obj;
  },

  create(base?: DeepPartial<ApiIntegrationOperationDelete>): ApiIntegrationOperationDelete {
    return ApiIntegrationOperationDelete.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ApiIntegrationOperationDelete>): ApiIntegrationOperationDelete {
    const message = createBaseApiIntegrationOperationDelete();
    message.id = object.id ?? "";
    message.integrationId = object.integrationId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
